import api from '../../utils/services/api';

import {
  loanDetailActionError,
  loanDetailActionLoading,
  loanDetailActionSuccess,
} from '../ducks/loanDetail';
import { showAlert } from '../ducks/sweetAlert';

export const loanDetailFetchAction = (params) => {
  return async (dispatch) => {
    dispatch(loanDetailActionLoading());
    try {
      const response = await api.get(
        `emprestimo/listar/cronograma?CODOPERACAO=${params}`,
      );
      dispatch(loanDetailActionSuccess(response.data));
    } catch (error) {
      const errorMessage = error?.response?.data?.mensagem;
      dispatch(
        showAlert({
          title: 'Ops...',
          text: errorMessage,
          icon: 'error',
        }),
      );
      dispatch(loanDetailActionError(error?.response?.data));
    }
  };
};
